<div class="contact-container">
  <ng-container
    *ngComponentOutlet="
      components()[config().variant].component;
      inputs: components()[config().variant].inputs
    "
  />
</div>
